import { createStyles, rem } from "@mantine/core";

export const useStyles = createStyles((theme) => ({
  paymentPage: {
    background:'#E4E4E7',
    display:"flex",
    justifyContent:'center',
    padding:'5rem 0'
  },
  centered: {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    textAlign: "center",
    // marginTop: rem(50),
    margin:0,
    background:'#fff !important',
    // padding:'5rem'
    // margin: "auto",
  },
  update:{
    color: "#fff",
    fontWeight: 600,
    textDecoration: "none",
    borderBottom: "1px solid #fff",
  },
  title: {
    fontSize: rem(34),
    fontWeight: 700,
    fontFamily: "Inter",
    marginBottom: rem(10)
  },
  subTitle: {
    // fontSize: rem(34),
    // fontWeight: 700,
    fontFamily: "Inter",
    marginBottom: rem(3),
    color:'#667085'
  },
  paymentFailedBox:{
    background: "#ff00009e",
    color: "#FFFF",
    padding: 20,
    borderRadius: 10,
    // marginTop: 10,
    marginBottom: 10,
    fontFamily: "Inter",
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
  },
  description: {
    fontSize: rem(16),
    fontWeight: 400,
    fontFamily: "Inter",
    color: "#979797"
  },
  logo: {
    marginTop: rem(20),
    marginBottom: rem(30)
  },
  type: {
    borderWidth: 1,
    borderRadius: 10,
    borderColor: "#97979726",
    borderStyle: "solid",
    padding: 20
  },
  selected: {
    borderWidth: 1,
    borderRadius: 10,
    borderColor: "#FFBA45",
    borderStyle: "solid",
    padding: 20
  },
  myfont: {
    fontFamily: "Inter",

    '& input':{
      background:"#fff",
      border:'1px solid #97979726'
    }
  },
  card: {
    width: "100%",
    marginTop: 0,
    overflow: "unset",
    padding:rem(20),
    boxShadow:'none',

    "& form":{
      display:'flex',
      gap:'0.5rem',
      flexDirection:'column',
      padding:'0 3rem'
    }
  },
  payBtn: {
    fontFamily: "Inter",
    marginTop: rem(50),
    marginBottom: rem(20)
  },
  m10: {
    marginTop: rem(10),
    marginBottom: rem(10),
    textAlign:'start'
  },
  font1: {
    fontSize: rem(20),
    fontWeight: 500,
    fontFamily: "Inter",
    cursor: "pointer"
  },
  font2: {
    fontSize: rem(16),
    fontWeight: 400,
    fontFamily: "Inter",
    color: "#979797"
  },
  back: {
    position: "absolute",
    top: rem(50),
    left: rem(50),
    fontSize: rem(16),
    fontFamily: "Inter",
    fontWeight: 500,
    "@media (max-width: 1024px)": {
      top: rem(100),
    }
  },
  plaidComponent: {
    // cursor: "pointer",
    border: "1px solid #F2F2F2",
    borderRadius: "10px",
    width: "65%",
    "@media (max-width: 900px)": {
      width: "80%"
    },
    "@media (max-width: 768px)": {
      width: "90%"
    }
  },
  connectBankImage: {
    width: "30%",
    "@media (max-width: 500px)": {
      width: "100%"
    }
  },
  insideFlex: {
    width: "60%",
    "@media (max-width: 500px)": {
      width: "95%",
      padding: "10px"
    }
  },
  inputs: {
    marginBottom:'.5rem',
    textAlign:'start'
  },
  method: {
    borderRadius: "12px",
    background: "#fff",
    padding: "8px 16px",
    cursor: "pointer",
    border: "2px solid #E4E4E7",
    width: "fit-content",
    display: "flex",
    gap: "10px",
    alignItems: "center",
  },
}));
